/**
* In Profile function is used to display the Admin details and its functions declare this file 
**/
import { goBack } from './../../../services/UtilsService';
import {Link} from 'react-router-dom';
import { useSelector } from 'react-redux'
import {convertS3privateToPublic} from './../../../services/UtilsService';
import { useTranslation } from 'react-i18next';

function Profile() {
	//Initial variable declaration
	const profileData=useSelector(state => state?.profile);
	const { t } = useTranslation();
	
	return(
	<main id="main" className="main">
	
	{/* Page Title Section */}
	<div className="pagetitle clearfix">
			<div className="float-start">
			  <h1>{t('header.myProfile')}</h1>
				<nav>
					<ol className="breadcrumb">
					  <li className="breadcrumb-item"><Link to='/admin/dashboard'>{t('sidebar.home')}</Link></li>
					  <li className="breadcrumb-item active">{t('header.myProfile')}</li>
					</ol>
				</nav>
			</div>
			<div className="float-end mt-2 me-1">
				<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
			</div>
	</div>
	{/*End Page Title Section*/}
		
		{/*Page Content Section*/}
		<div className="row">
			
			<div className="col-lg-4">
				{/*Profile Image*/}
				<div className="card profile-img">
					<div className="card-body">
						<div className="top-bar">
							<img className="img-fluid d-block mx-auto" src={profileData?.photo==='default.png'?"../assets/img/user-avatar.png":convertS3privateToPublic(profileData?.photo)} alt="logo" />
							<h1 className="text-capitalize">{profileData?.first_name+' '+profileData?.last_name}</h1>
						</div>
						<div className="center-bar clearfix">
							<div className="d-flex align-items-center mb-4">
								<div className="info-icon">
									<i className="iconly-Bold-Send"></i>
								</div>
								<div className="ms-2">
									<p className="mb-0 text-tmBlue">{t('profile.email')}</p>
									<span className="h6 text-dark" style={{ wordBreak : "break-word"}}>{profileData?.email}</span>
								</div>
							</div>
						</div>
						<div className="d-grid mt-4">
							<Link to='/admin/edit-profile'  className="btn btn-block btn-outline-tmBlue">
								<i className="ri-edit-2-fill align-middle"></i> {t('profile.editProfile')}
							</Link>
						</div>
					</div>
				</div>
            </div>
			{/*User Info Section*/}
			{/*<div className="col-lg-8">
				<div className="card profile-info">
					<div className="card-body pt-4">
						<div className="row">
							<div className="col-xxl-12 px-3 mb-5">
								<div className="secTitle">
									<h1>{t('profile.userInfo}</h1>
								</div>
								<div className="secContent">
									<div className="table-responsive">	
										<table className="table table-borderless theme-table">
											<thead>
											  <tr>
												<th scope="col">{constantVariables.auth.userName}</th>
												<th scope="col">{t('profile.userId}</th>
												<th scope="col">{constantVariables.auth.password}</th>
												<th scope="col" className="text-center">{t('profile.action}</th>
											  </tr>
											</thead>
											<tbody>
												<tr>					
													<td>Sankar Ganesh</td>				
													<td>sankar-ganesh</td>				
													<td>***************</td>				
													<td className="text-center fw-normal">
														<span className="text-danger"><i className="ri-delete-bin-7-line align-middle h6"></i></span>
													</td>
												</tr>
												<tr>
													<td>Viswanathan</td>				
													<td>viswanathan</td>				
													<td>***************</td>				
													<td className="text-center fw-normal">
														<span className="text-danger"><i className="ri-delete-bin-7-line align-middle h6"></i></span>
													</td>
												</tr>
												<tr>
													<td>Santhosh Narayanan</td>				
													<td>santhoshn</td>				
													<td>*************</td>				
													<td className="text-center fw-normal">
														<span className="text-danger"><i className="ri-delete-bin-7-line align-middle h6"></i></span>
													</td>
												</tr>
											</tbody>
									    </table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>*/}

			<div className="col-lg-8">
				<div className="card profile-info">
					<div className="card-body pt-4">
						{/*Admin Info*/}
						<div className="row">
							<div className="col-xxl-12 px-3 mb-5">
								<div className="secTitle">
									<h1>{t('profile.profileInfo')}</h1>
								</div>
								<div className="secContent">
									<div className="row">
										<div className="col-lg-6 px-3">
											<h6>{t('profile.adminName')}</h6>
											<p style={{ 'textTransform' : 'capitalize'}}>{profileData?.first_name+' '+profileData?.last_name}</p>
										</div>
										<div className="col-lg-6 px-3">
											<h6>{t('profile.role')}</h6>
											<p>{t('landing.admin')}</p>
										</div>
										<div className="col-lg-4 px-3">
											<h6>{t('profile.emailAddress')}</h6>
											<p>{profileData?.email?profileData?.email:'--'}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
		{/*End Page Content Section*/}
	</main>
	);
}

export default Profile;
